<script setup></script>

<template>
  <RouterView></RouterView>
</template>
 
<style src="./assets/style.scss" lang="scss"></style>
